/* eslint-disable jsx-a11y/no-access-key */
import React, { useEffect, useState } from 'react';
import { IconList16, IconChevronLeft16, IconChevronRight16 } from '@fabric-ds/icons/react';
import PropTypes from 'prop-types';
import { getPagingData, handlePagingKeyDown, loadFromStorage } from './pagingData';

const Paging = ({ finnkode }) => {
    const [pagingData, setPagingData] = useState(null);

    useEffect(() => {
        const data = getPagingData(finnkode, loadFromStorage);

        setPagingData(data);
        if (data && data.next) {
            document.addEventListener('keydown', handlePagingKeyDown(data.next));
        }
    }, [finnkode]);

    return (
        pagingData && (
            <div data-testid="objectpage-paging">
                <nav className="flex gap-x-20 items-center justify-between">
                    <a href={pagingData.search} aria-label="Til søket" accessKey="s" data-testid="to-search">
                        <IconList16 />
                        <span />
                    </a>
                    {pagingData.prev && (
                        // TODO: add tracking once ready
                        <a
                            href={pagingData.prev}
                            rel="prev"
                            aria-label="Forrige annonse"
                            accessKey="f"
                            data-testid="to-prev"
                        >
                            <IconChevronLeft16 />
                        </a>
                    )}
                    {pagingData.next && (
                        // TODO: add tracking once ready
                        <a
                            href={pagingData.next}
                            rel="next"
                            aria-label="Neste annonse"
                            accessKey="n"
                            data-testid="to-next"
                        >
                            <IconChevronRight16 />
                        </a>
                    )}
                </nav>
            </div>
        )
    );
};

Paging.propTypes = {
    finnkode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Paging;
